import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const DELETE_DATA_DOC_URL = `${process.env.PUBLIC_URL || ''}/DELETE_DATA_PAGE.md`;

export default function DeleteDataPage() {
  const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetch(DELETE_DATA_DOC_URL)
      .then((res) => {
        if (!res.ok) throw new Error('Could not load delete data information.');
        return res.text();
      })
      .then((text) => {
        if (!cancelled) {
          setMarkdown(text);
          setLoading(false);
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e.message || 'Failed to load');
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Button
            component="a"
            href="/"
            startIcon={<ArrowBackIcon />}
            color="inherit"
            sx={{ mr: 2 }}
          >
            Home
          </Button>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Delete your data
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ py: 4 }}>
        {loading && (
          <Box display="flex" justifyContent="center" py={8}>
            <CircularProgress />
          </Box>
        )}
        {error && <Alert severity="error">{error}</Alert>}
        {!loading && !error && (
          <Box
            sx={{
              '& h1': { typography: 'h4', fontWeight: 700, mb: 2, mt: 0 },
              '& h2': { typography: 'h6', fontWeight: 600, mt: 4, mb: 1.5 },
              '& h3': { typography: 'subtitle1', fontWeight: 600, mt: 3, mb: 1 },
              '& p': { typography: 'body1', mb: 1.5 },
              '& ul': { pl: 3, my: 1.5 },
              '& ol': { pl: 3, my: 1.5 },
              '& li': { mb: 0.75, typography: 'body1' },
              '& hr': { my: 3, border: 0, borderTop: '1px solid', borderColor: 'divider' },
              '& strong': { fontWeight: 700 },
              '& a': { color: 'primary.main' },
            }}
          >
            <ReactMarkdown>{markdown}</ReactMarkdown>
          </Box>
        )}
      </Container>
    </Box>
  );
}
